import React, { forwardRef } from 'react';
import { DeviceCardElement, DeviceCardContainer, IconContainer, } from './deviceCardBodyElements';
import { Tag } from '../Tag';
import { Text } from '../Text';
import { Icon } from '../Icon';
import { InternalProvider } from '../../util/InternalProvider';
import { colors } from '../../abstracts';
import { useComponentDeprecation } from '../../util';
/**
  @deprecated DeviceCardBody is deprecated and will be deleted in v3. Please use DeviceCard instead.
 */
export var DeviceCardBody = forwardRef(function (_a, fRef) {
    var iconSrc = _a.iconSrc, primary = _a.primary, secondary = _a.secondary, tertiary = _a.tertiary, tagType = _a.tagType, tagText = _a.tagText;
    useComponentDeprecation({
        name: 'DeviceCardBody',
        alternative: 'DeviceCard',
        version: '3.0.0'
    });
    return (React.createElement(InternalProvider, null,
        React.createElement(DeviceCardContainer, { ref: fRef },
            iconSrc && (React.createElement(IconContainer, null,
                React.createElement(Icon, { src: iconSrc, size: "84px" }))),
            primary && (React.createElement(DeviceCardElement, null,
                React.createElement(Text, { size: 2, weight: "base" }, primary))),
            secondary && (React.createElement(DeviceCardElement, null,
                React.createElement(Text, { size: 1, weight: "base", color: colors.neutralDeeper }, secondary))),
            tertiary && (React.createElement(DeviceCardElement, null,
                React.createElement(Text, { size: 1, weight: "base", color: colors.neutralDeeper }, tertiary))),
            tagText && (React.createElement(DeviceCardElement, null,
                React.createElement(Tag, { text: tagText, type: tagType, size: "small" }))))));
});
